import React, { Component } from "react";
import { connect } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";

import Aux from "../Aux";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import Toolbar from "./components/Toolbar";
import { WrappedTable, filterString } from "../Table";
import { getUsers, removeUser } from "../../store/Users/services";

const CheckboxTable = checkboxHOC(ReactTable);

const columns = [
  {
    accessor: "first_name",
    Header: "First Name",
    filterMethod: filterString,
    Cell: props => (
      <a href={"/users/edit/" + props.original.id}>{props.value}</a>
    )
  },
  {
    accessor: "last_name",
    Header: "Last Name",
    filterMethod: filterString,
    Cell: props => (
      <a href={"/users/edit/" + props.original.id}>{props.value}</a>
    )
  },
  {
    accessor: "email",
    Header: "Email Address",
    filterable: true
  },
  {
    accessor: null,
    Header: null,
    filterable: false,
    Cell: props => (
      <div className="text-center">
        <Link to={"/users/edit/" + props.original.id}>
          <Button outline size="sm">
            Edit
          </Button>
        </Link>
      </div>
    )
  }
];

class List extends Component {
  constructor(props) {
    super(props);

    this.remove = this.remove.bind(this);
  }

  getData = (perPage, offset) => {
    this.props.dispatch(getUsers(perPage, offset));
  };

  componentWillMount() {
    this.getData();
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected and entries");
    }
    const result = window.confirm(
      "Are you sure you want to remove these entries?"
    );
    if (result) {
      //items = items.join(",");
      this.props.dispatch(removeUser(items));
    }
  }

  render() {
    const { loading, checkboxProps } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Users" />
        <Toolbar
          permissions={this.props.permissions}
          createLink={"/users/create"}
          total={this.props.data.length}
          handleDelete={() => this.remove()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "60px" }}
        >
          <CheckboxTable
            ref={r => (this.checkboxTable = r)}
            keyField="id"
            data={this.props.data}
            showPaginationBottom
            filterable
            columns={columns}
            loading={this.props.loading}
            defaultPageSize={20}
            style={{
              height: "100vh"
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    data: store.user.users,
    permissions: store.auth.permissions,
    loading: store.user.isLoading,
    success: store.user.success
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/system/containers/Users/List.jsx